import { Skeleton } from "@mui/material";
import Table from "components/Table";
import useIsMobileView from "hooks/useIsMobileView";

const headers = [
  {
    key: 1,
    name: <Skeleton variant="text" width={40} />,
    align: "center",
  },
  {
    key: 2,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 3,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 4,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 5,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 6,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 7,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
];

const headersMobile = [
  {
    key: 1,
    name: <Skeleton variant="text" width={40} />,
    align: "center",
  },
  {
    key: 2,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
  {
    key: 3,
    align: "center",
    name: <Skeleton variant="text" width={40} />,
  },
];

const items = [
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
  {
    1: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    2: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    3: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    4: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    5: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    6: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
    7: <Skeleton sx={{ margin: "auto" }} variant="text" width={40} />,
  },
];

function TableSkeleton() {
  const isMobileView = useIsMobileView();

  return (
    <Table headers={isMobileView ? headersMobile : headers} items={items} />
  );
}

export default TableSkeleton;
